<template>
  <Popup
      style="width: 100%;height: 100%;"
      :value="show"
      @click-overlay="show = false"
      @click-close-icon="show = false"
      :close-on-click-overlay="false"
      closeable
  >
    <div v-if="show" @click.self="show = false"
         style="height: 100%;width: 100%;background: #000;display: flex;align-items: center">
      <video controlsList="nodownload" webkit-playsinline x5-playsinline style="width: 100%" controls :src="src" :poster="cover"></video>
    </div>
  </Popup>
</template>

<script>
import {Popup} from 'vant';

export default {
  name: 'VideoPopup',

  data() {
    return {

      show: false,
      cover: '', src: ""
    }
  },
  methods: {
    openPopup(src, c) {
      this.src = src
      this.cover = c
      this.show = true;
    },
    clickConfirm() {
      this.show = false
      this.$emit('ok')
    },
    closePopup() {
      this.show = false
      this.$emit('close')
    },
  },
  components: {Popup}
}
</script>

<style scoped lang="scss">

</style>
